export const TYPE_LABELS = {
  territory: 'Территория',
  building: 'Здание',
  floor: 'Этаж',
  room: 'Помещение',
};

export const flattenTree = (nodes) => {
  let result = [];
  const walk = (list) => {
    list.forEach(node => {
      const { children, ...data } = node;
      result.push(data);
      if (children?.length) walk(children);
    });
  };
  walk(nodes);
  return result;
};

export const buildDescendantSet = (rootId, allObjects) => {
  const set = new Set();
  const queue = [rootId];
  while (queue.length) {
    const cur = queue.shift();
    set.add(cur);
    allObjects.forEach(o => {
      if (o.parent_id === cur) queue.push(o.id);
    });
  }
  return set;
};
